<template>
    <div v-if="initDataLoaded">
        <v-layout row wrap>
            <v-flex xs6 md1>
                <v-text-field 
                    v-model="searchParams.zip" 
                    label="ZIP Code"
                    hint="ZIP Code Assigned to Sales Rep."
                    ></v-text-field>
            </v-flex>
            <v-flex xs6 md1 pl-2>
                <v-text-field 
                    v-model="searchParams.territoryId" 
                    label="Territory"
                    hint="Territory Assigned to Sales Rep."
                    ></v-text-field>
            </v-flex>
            <v-flex xs6 md2 pl-2>
                <v-text-field 
                    v-model="searchParams.name" 
                    label="Name"
                    hint="Name of Sales Rep."
                    ></v-text-field>
            </v-flex>
            <v-flex xs6 md2 pl-2>
                    <v-select 
                    label="State"
                    :items="allUsStates()"
                    v-model="searchParams.state"
                    item-text="name"
                    item-value="abbreviation"
                    hint=""
                    persistent-hint
                    ></v-select>

            </v-flex>
            <v-flex xs12 md2 pl-2>
                <v-text-field
                    v-model="searchParams.country"
                    label="Country"
                    hint="Find Export Dealer"></v-text-field>
            </v-flex>
            <v-flex xs12 md4 text-xs-center>
                <v-btn color="primary" @click.prevent="searchSalesRep">Submit</v-btn>
                <v-btn color="primary" @click.prevent="resetSearchParams">Reset</v-btn>
            </v-flex>
        </v-layout>
        <!-- {{getUserDefaultQuoteSearchCriteria()}} -->
        <!-- {{searchParams}} -->
    </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'

export default {
    props: ['allowSearchNoParas'],
    data () {
        return {
            // allLookups: null,
            // public bool? isActive { get; set; }
            // public int? zip { get; set; }
            // public string territoryId { get; set; }
            // public string repEmail { get; set; }
            searchParams: null,
            foundSearchParamsInState: false, //why need this? if searchParams loaded from state, we will not change page to 1
        }
    },
    computed: {
        initDataLoaded () {
            return true     //this.allLookups && this.searchParams
        },
    },
    methods: {
        // ...mapActions('pubQuoteSearch', [
        //     'getUserDefaultQuoteSearchCriteria',
        //     'getUserDefaultQuoteSearchLookups',
        // ]),
        searchSalesRep () {
            if(this.searchParams) {
                if(!this.allowSearchNoParas 
                    && !this.searchParams.zip 
                    && !this.searchParams.state
                    && !this.searchParams.name
                    && !this.searchParams.country
                    && !this.searchParams.territoryId) {
                    alert('No Search Criteria Found!')
                    return
                }
                // console.log('kkkkl')
                this.$emit('onSearchParamsChanged', this.searchParams)

            }
        },
        resetSearchParams() {
            const defaultParas = {
                // page: 1,
                // recordsPerPage: 10,
                isActive: true,
                zip: null,
                territoryId: null,
                name: null,
                country: null,
            }
            this.searchParams = defaultParas
        }
    },
    watch: {
        // searchParams: {
        //     handler: function (newVal, oldVal) {
        //         this.searchQuotes()
        //     },
        //     deep: true
        // },
    },
    async created () {
        this.resetSearchParams()

    },

}
</script>
